import React, { useState, useEffect } from "react";
import { Grid } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import BiztranControls from "../../biztran_controls/BiztranControls";
import BiztranControlsFormik from "../../biztran_controls_formik/BiztranControlsFormik";
import UseFetchData from "../../../hooks/UseFetchData";

const CreateProduct = (props) => {
    const [Mode, setMode] = useState('');
    const [ProductName, setProductName] = useState('');
    const [DisplayTitle, setDisplayTitle] = useState('');
    const [ShortDescription, setShortDescription] = useState('');
    const [LongDescription, setLongDescription] = useState('');
    const [ProductTypeID, setProductTypeID] = useState('');
    const [ProductGroupID, setProductGroupID] = useState('');
    const [MakeID, setMakeID] = useState('');
    const [response, fetchData] = UseFetchData();

    const [ProductTypecmb, setProductTypecmb] = useState([]);
    const [ProductGroupcmb, setProductGroupcmb] = useState([]);
    const [ProductMakecmb, setProductMakecmb] = useState([]);
    const [ComboDataResponse, fetchComboData] = UseFetchData();
    const [responseGetData, fetchDataGetData] = UseFetchData();

    const validationSchema = Yup.object({
        ProductName: Yup.string().required('Required!'),
        DisplayTitle: Yup.string().required('Required!'),
        ProductTypeID: Yup.string().required('Required!'),
        ProductGroupID: Yup.string().required('Required!'),
        MakeID: Yup.string().required('Required!'),
        ShortDescription: Yup.string().required('Required!'),
        LongDescription: Yup.string().required('Required!')
    });

    const onSubmit = values => {
        setMode('Insert');
        var bodyFormData = new FormData();
        bodyFormData.append("ProductID", props.ProductID);
        bodyFormData.append("ProductName", values.ProductName);
        bodyFormData.append("DisplayTitle", values.DisplayTitle);
        bodyFormData.append("ProductTypeID", values.ProductTypeID);
        bodyFormData.append("ProductGroupID", values.ProductGroupID);
        bodyFormData.append("MakeID", values.MakeID);
        bodyFormData.append("ShortDescription", values.ShortDescription);
        bodyFormData.append("LongDescription", values.LongDescription);
        fetchData("product/Save", bodyFormData);
    }

    useEffect(() => {
        if (response.Response === true) {
            props.setOpen(false);
            // debugger;
            props.PopulateData();
        }
        else if (response.Response === false) {
            if (response.Message.includes("Already") === true) {
                alert(response.Message);
            }
            else {
                alert("Failed.");
            }
        }
        if (props.ProductID !== "") {
            setMode("Update");
        } else {
            setMode("Insert");
        }

        if (response.length > 0 && Mode === "Update") {
            setProductName(response[0].ProductName);
            setDisplayTitle(response[0].DisplayTitle);
            setProductTypeID(response[0].ProductTypeID);
            setProductGroupID(response[0].ProductGroupID);
            setMakeID(response[0].MakeID);
            setShortDescription(response[0].ShortDescription);
            setLongDescription(response[0].LongDescription);
        }
    }, [response]);

    const ProductTypeData = (options) => {
        if (options !== undefined) {
            let ProductType = options.map((data) =>
                <option
                    key={data.ProductType}
                    value={data.ProductTypeID}
                >
                    {data.ProductType}
                </option>
            );
            setProductTypecmb(ProductType)
        }
    }
    const ProductGroupData = (options) => {
        if (options !== undefined) {
            let ProductGroup = options.map((data) =>
                <option
                    key={data.ProductGroup}
                    value={data.ProductGroupID}
                >
                    {data.ProductGroup}
                </option>
            );
            setProductGroupcmb(ProductGroup)
        }
    }
    const ProductMakeData = (options) => {
        if (options !== undefined) {
            let ProductMake = options.map((data) =>
                <option
                    key={data.Make}
                    value={data.MakeID}
                >
                    {data.Make}
                </option>
            );
            setProductMakecmb(ProductMake)
        }
    }

    const GetByIDData = () => {
        var bodyFormData = new FormData();
        bodyFormData.append("ProductID", props.ProductID);
        fetchDataGetData("product/GetByID", bodyFormData);
    }

    useEffect(() => {
        if (responseGetData !== undefined && responseGetData.length > 0) {
            setProductName(responseGetData[0].ProductName);
            setDisplayTitle(responseGetData[0].DisplayTitle);
            setProductTypeID(responseGetData[0].ProductTypeID);
            setProductGroupID(responseGetData[0].ProductGroupID);
            setMakeID(responseGetData[0].MakeID);
            setShortDescription(responseGetData[0].ShortDescription);
            setLongDescription(responseGetData[0].LongDescription);
        }
    }, [responseGetData]);

    useEffect(() => {
        if (ComboDataResponse !== undefined) {
            if (ComboDataResponse["ProductType"] !== undefined
                && ComboDataResponse["ProductGroup"] !== undefined
                && ComboDataResponse["ProductMake"] !== undefined
            ) {
                ProductTypeData(ComboDataResponse["ProductType"]);
                ProductGroupData(ComboDataResponse["ProductGroup"]);
                ProductMakeData(ComboDataResponse["ProductMake"]);

                if (props.ProductID !== "" && props.Mode === "Update") {
                    setMode("Update");
                    GetByIDData();
                } else {
                    setMode("Insert")
                }
            }
        }
    }, [ComboDataResponse]);

    useEffect(() => {
        GetComboData();

    }, [])
    const GetComboData = () => {
        fetchComboData("product/ComboData");
    };

    const onSelectChange = (e) => {
        let targetvalue = e.target.value;
        let targetname = e.target.name;
        if (targetvalue !== "") {
            if (targetname === "ProductTypeID") {
                setProductTypeID(targetvalue)
            }
            else if (targetname === "ProductGroupID") {
                setProductGroupID(targetvalue)
            }
            else if (targetname === "MakeID") {
                setMakeID(targetvalue)
            }
        }
        else {
            if (targetname === "ProductTypeID") {
                setProductTypeID("")
            }
            else if (targetname === "ProductGroupID") {
                setProductGroupID("")
            }
            else if (targetname === "MakeID") {
                setMakeID("")
            }
        }
    }

    return (
        <div>
            <Formik initialValues={{
                ProductName: ProductName, ProductTypeID: ProductTypeID, ProductGroupID: ProductGroupID, MakeID: MakeID,
                DisplayTitle: DisplayTitle, ShortDescription: ShortDescription, LongDescription: LongDescription,
            }}
                validationSchema={validationSchema} onSubmit={onSubmit} enableReinitialize>
                {formik => {
                    return <Form>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={3}><label htmlFor={"ProductName"} style={{ display: 'block', width: '100%' }}>{"Product Details"}</label></Grid>
                            <Grid item xs={9}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    // label='Account Code'
                                    name='ProductName'
                                    onChange={(e) => setProductName(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label htmlFor={"DisplayTitle"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Display Title"}
                                </label>
                            </Grid>
                            <Grid item xs={9}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    // label='WebSite'
                                    name='DisplayTitle'
                                    onChange={(e) => setDisplayTitle(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label htmlFor={"ProductTypeID"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Product Type"}
                                </label>
                            </Grid>
                            <Grid item xs={9}>
                                <BiztranControlsFormik
                                    control='select'
                                    // label='Account Group'
                                    name='ProductTypeID'
                                    options={ProductTypecmb}
                                    // onChange={onSelectChange}
                                    onChange={(e) => setProductTypeID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label htmlFor={"ProductGroupID"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Product Group"}
                                </label>
                            </Grid>
                            <Grid item xs={9}>
                                <BiztranControlsFormik
                                    control='select'
                                    // label='Account Type'
                                    name='ProductGroupID'
                                    options={ProductGroupcmb}
                                    //onChange={onSelectChange}
                                    onChange={(e) => setProductGroupID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label htmlFor={"MakeID"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Product Make"}
                                </label>
                            </Grid>
                            <Grid item xs={9}>
                                <BiztranControlsFormik
                                    control='select'
                                    // label='Industry'
                                    name='MakeID'
                                    options={ProductMakecmb}
                                    //onChange={onSelectChange}
                                    onChange={(e) => setMakeID(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label htmlFor={"ShortDescription"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Short Description"}
                                </label>
                            </Grid>
                            <Grid item xs={9}>
                                <BiztranControlsFormik
                                    control='input'
                                    type='text'
                                    // label='WebSite'
                                    name='ShortDescription'
                                    onChange={(e) => setShortDescription(e.target.value)}
                                />
                            </Grid>
                            <Grid item xs={3}>
                                <label htmlFor={"LongDescription"}
                                    style={{
                                        display: 'block', width: '100%'
                                    }}>
                                    {"Long Description"}
                                </label>
                            </Grid>
                            <Grid item xs={9}>
                                <BiztranControlsFormik
                                    control='textarea'
                                    type='text'
                                    // label='Description'
                                    name='LongDescription'
                                    onChange={(e) => setLongDescription(e.target.value)}
                                />
                            </Grid>
                        </Grid>
                        <Grid spacing={2} container direction="row">
                            <Grid item xs={12}>
                                <div style={{ width: '100%' }}>
                                    <div style={{ display: 'flex', justifyContent: 'center', alignContent: "center" }}>
                                        <BiztranControls.Button
                                            text="SAVE"
                                            type="submit"
                                            startIcon={<SaveIcon />}
                                        />
                                        <BiztranControls.Button
                                            text="CLOSE"
                                            startIcon={<CloseIcon />}
                                            onClick={() => { props.setOpen(false); }}
                                        />
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </Form>
                }}
            </Formik>
        </div>
    );
};

export default CreateProduct;
